/** @format */
import React from "react";
import Link from "next/link";
const CommonBreadcrumbs = (props) => {
  const { breadcrumbs } = props;
  return (
    <ul
      className={`breadcums padding-top d-flex align-items-center justify-content-center`}
    >
      <li>
        <Link href="/">Home</Link>
      </li>
      {breadcrumbs.map((item, index) => {
        return (
          <li key={item.href + index}>
            {item.href ? (
              <Link href={item.href}>{item.name}</Link>
            ) : (
              <span>{item.name} </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default React.memo(CommonBreadcrumbs);
